// --- 1. CORE BOGO LOGIC ---
async function enforceRegaliaBOGO() {
  const goldId = 46849466237177; 
  const silverId = 46849466204409; 

  const cartResponse = await fetch('/cart.js');
  const cart = await cartResponse.json();

  let quantities = {
    paidGold: 0, freeGold: 0,
    paidSilver: 0, freeSilver: 0
  };
  
  let keys = { freeGoldKey: null, freeSilverKey: null };

  // Tally up the cart contents
  cart.items.forEach(item => {
    const isFree = item.properties && item.properties._is_free === 'true';

    if (item.variant_id === goldId) {
      if (isFree) { 
        quantities.freeGold += item.quantity; 
        keys.freeGoldKey = item.key; 
      } else { 
        quantities.paidGold += item.quantity; 
      }
    }

    if (item.variant_id === silverId) {
      if (isFree) { 
        quantities.freeSilver += item.quantity; 
        keys.freeSilverKey = item.key; 
      } else { 
        quantities.paidSilver += item.quantity; 
      }
    }
  });

  let updatesNeeded = false;
  let ajaxPromises = [];

  // Logic: Paid Gold requires Free Silver
  if (quantities.freeSilver !== quantities.paidGold) {
    if (quantities.freeSilver === 0 && quantities.paidGold > 0) {
      ajaxPromises.push(addFreeItem(silverId, quantities.paidGold));
    } else if (keys.freeSilverKey) {
      ajaxPromises.push(updateItemQty(keys.freeSilverKey, quantities.paidGold));
    }
    updatesNeeded = true;
  }

  // Logic: Paid Silver requires Free Gold
  if (quantities.freeGold !== quantities.paidSilver) {
    if (quantities.freeGold === 0 && quantities.paidSilver > 0) {
      ajaxPromises.push(addFreeItem(goldId, quantities.paidSilver));
    } else if (keys.freeGoldKey) {
      ajaxPromises.push(updateItemQty(keys.freeGoldKey, quantities.paidSilver));
    }
    updatesNeeded = true;
  }

  // Execute changes
  if (updatesNeeded) {
    await Promise.all(ajaxPromises);
    
    // Attempt to refresh the cart drawer UI (Works natively for Dawn and similar themes)
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    
    // If your drawer still doesn't visually update, you can force a page reload by uncommenting the line below:
    // window.location.reload();
  }
}

// --- 2. HELPER FUNCTIONS ---
function addFreeItem(variantId, qty) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: qty,
        properties: { '_is_free': 'true' } 
      }]
    })
  });
}

function updateItemQty(lineKey, newQty) {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      updates: { [lineKey]: newQty }
    })
  });
}

// --- 3. THE TRIGGER (FETCH INTERCEPTOR) ---
// This listens to all cart activity in the background and fires the logic above
let isBogoRunning = false;
const originalFetch = window.fetch;

window.fetch = async function () {
  const response = await originalFetch.apply(this, arguments);
  const url = arguments[0];
  
  // Make sure the URL is a string and is interacting with the cart
  if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
    
    // Prevent the script from triggering itself in an infinite loop
    if (!isBogoRunning) {
      isBogoRunning = true; 
      
      try {
        await enforceRegaliaBOGO();
      } catch (e) {
        console.error("BOGO Script Error:", e);
      } finally {
        isBogoRunning = false; 
      }
    }
  }
  
  return response;
};